<app-breadcrumbs title="Demands" [breadcrumbItems]="breadCrumbItems"></app-breadcrumbs>

<div class="row">
  <div class="col-lg-12">
    <div class="card">
  <div class="card-header d-flex justify-content-between align-items-center">
    <h5>Material Demands</h5>
    <button class="btn btn-success" (click)="toggleForm()">
      <i [class]="showForm ? 'ri-close-line' : 'ri-add-line'"></i>
      {{ showForm ? 'Cancel' : 'Create Demand' }}
    </button>
  </div>

  <div *ngIf="showForm" class="card-body border-bottom">
    <form [formGroup]="demandForm" (ngSubmit)="saveDemand()">
      <div class="row g-3">
        <div class="col-md-4">
          <label>Required By Date <span class="text-danger">*</span></label>
          <input type="date" formControlName="required_by_date" class="form-control" 
                 [class.is-invalid]="submitted && f['required_by_date'].errors" />
          <div *ngIf="submitted && f['required_by_date'].errors" class="invalid-feedback">
            <span *ngIf="f['required_by_date'].errors['required']">Required by date is required</span>
          </div>
        </div>
        <div class="col-md-4">
          <label>Priority <span class="text-danger">*</span></label>
          <select formControlName="priority" class="form-control" 
                  [class.is-invalid]="submitted && f['priority'].errors">
            <option value="">Select Priority</option>
            <option *ngFor="let priority of priorityOptions" [value]="priority">{{ priority }}</option>
          </select>
          <div *ngIf="submitted && f['priority'].errors" class="invalid-feedback">
            <span *ngIf="f['priority'].errors['required']">Priority is required</span>
          </div>
        </div>
        <div class="col-md-4">
          <label>Purpose <span class="text-danger">*</span></label>
          <input formControlName="purpose" class="form-control" 
                 [class.is-invalid]="submitted && f['purpose'].errors" placeholder="Enter purpose" />
          <div *ngIf="submitted && f['purpose'].errors" class="invalid-feedback">
            <span *ngIf="f['purpose'].errors['required']">Purpose is required</span>
          </div>
        </div>
        <div class="col-md-12">
          <label>Remarks</label>
          <textarea formControlName="remarks" class="form-control" rows="2" placeholder="Enter remarks"></textarea>
        </div>
      </div>

      <!-- Suppliers Section -->
      <div class="mt-4">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="mb-0">Suppliers & Items <span class="text-danger">*</span></h6>
          <button type="button" class="btn btn-sm btn-primary" (click)="addSupplier()">
            <i class="ri-add-line"></i> Add Supplier
          </button>
        </div>

        <div formArrayName="suppliers">
          <div *ngFor="let supplier of demandSuppliers.controls; let si = index" [formGroupName]="si" 
               class="border rounded p-3 mb-3 bg-light">
            
            <!-- Supplier Selection -->
            <div class="row g-3 mb-3">
              <div class="col-md-10">
                <label>Supplier <span class="text-danger">*</span></label>
                <select formControlName="supplier_id" class="form-control" 
                        [class.is-invalid]="submitted && supplier.get('supplier_id')?.errors">
                  <option value="">Select Supplier</option>
                  <option *ngFor="let sup of suppliers" [value]="sup.id">
                    {{ sup.name || sup.supplier_name || 'Supplier #' + sup.id }}
                  </option>
                </select>
                <div *ngIf="submitted && supplier.get('supplier_id')?.errors" class="invalid-feedback">
                  <span *ngIf="supplier.get('supplier_id')?.errors?.['required']">Supplier is required</span>
                </div>
              </div>
              <div class="col-md-2 d-flex align-items-end">
                <button type="button" class="btn btn-danger w-100" (click)="removeSupplier(si)" 
                        [disabled]="demandSuppliers.length === 1">
                  <i class="ri-delete-bin-line"></i> Remove
                </button>
              </div>
            </div>

            <!-- Items for this Supplier -->
            <div class="ms-3">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <small class="text-muted fw-bold">Items for this supplier</small>
                <button type="button" class="btn btn-sm btn-outline-primary" (click)="addItem(si)">
                  <i class="ri-add-line"></i> Add Item
                </button>
              </div>

              <div formArrayName="items">
                <div *ngFor="let item of getSupplierItems(si).controls; let ii = index" [formGroupName]="ii" 
                     class="border rounded p-2 mb-2 bg-white">
                  <div class="row g-2">
                    <div class="col-md-3">
                      <label class="small">Item <span class="text-danger">*</span></label>
                      <select formControlName="item_id" class="form-control form-control-sm" 
                              [class.is-invalid]="submitted && item.get('item_id')?.errors">
                        <option value="">Select Item</option>
                        <option *ngFor="let itm of getItemsForSupplier(supplier.get('supplier_id')?.value)" [value]="itm.id">
                          {{ itm.name || itm.item_name || 'Item #' + itm.id }}
                        </option>
                      </select>
                      <div *ngIf="submitted && item.get('item_id')?.errors" class="invalid-feedback">
                        <span *ngIf="item.get('item_id')?.errors?.['required']">Required</span>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <label class="small">Quantity <span class="text-danger">*</span></label>
                      <input type="number" formControlName="requested_quantity" class="form-control form-control-sm" 
                             [class.is-invalid]="submitted && item.get('requested_quantity')?.errors" 
                             placeholder="Qty" />
                      <div *ngIf="submitted && item.get('requested_quantity')?.errors" class="invalid-feedback">
                        <span *ngIf="item.get('requested_quantity')?.errors?.['required']">Required</span>
                      </div>
                    </div>
                    <!-- <div class="col-md-2">
                      <label class="small">Expected Delivery <span class="text-danger">*</span></label>
                      <input type="date" formControlName="expected_delivery_date" class="form-control form-control-sm" 
                             [class.is-invalid]="submitted && item.get('expected_delivery_date')?.errors" />
                      <div *ngIf="submitted && item.get('expected_delivery_date')?.errors" class="invalid-feedback">
                        <span *ngIf="item.get('expected_delivery_date')?.errors?.['required']">Required</span>
                      </div>
                    </div> -->
                    <div class="col-md-2">
                      <label class="small">Specifications</label>
                      <input formControlName="specifications" class="form-control form-control-sm" placeholder="Specs" />
                    </div>
                    <div class="col-md-2">
                      <label class="small">Item Remarks</label>
                      <input formControlName="remarks" class="form-control form-control-sm" placeholder="Remarks" />
                    </div>
                    <div class="col-md-1 d-flex align-items-end">
                      <button type="button" class="btn btn-sm btn-danger w-100" (click)="removeItem(si, ii)" 
                              [disabled]="getSupplierItems(si).length === 1">
                        <i class="ri-delete-bin-line"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-3 text-end">
        <button class="btn btn-light" type="button" (click)="toggleForm()">Cancel</button>
        <button class="btn btn-success" type="submit">{{ isEditMode ? 'Update' : 'Save' }}</button>
      </div>
    </form>
  </div>

  <div class="card-body">
    <div *ngIf="isLoading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <div *ngIf="!isLoading">
      <table class="table">
        <thead class="table-light">
          <tr>
            <th>Demand #</th>
            <th>Required By</th>
            <th>Priority</th>
            <th>Purpose</th>
            <th>Items</th>
            <th>Status</th>
            <th>Created By</th>
            <th>Date</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="demands.length === 0">
            <td colspan="9" class="text-center py-4">
              <div class="text-muted">
                <i class="ri-inbox-line fs-1"></i>
                <p class="mt-2">No demands found</p>
              </div>
            </td>
          </tr>
          <tr *ngFor="let demand of demands">
            <td>
              <strong>{{ demand?.demandNumber }}</strong>
              <small class="text-muted d-block">{{ demand?.organizationalUnit?.name }}</small>
            </td>
            <td>{{ demand?.requiredByDate  | date:'mediumDate' }}</td>
            <td>
              <span class="badge" [ngClass]="getPriorityClass(demand.priority)">
                {{ demand.priority }}
              </span>
            </td>
            <td>{{ demand.purpose }}</td>
            <td>
              <span class="badge bg-info">{{ demand?.items?.length || 0 }} item(s)</span>
              <div *ngIf="demand?.items && demand.items.length > 0" class="small text-muted mt-1">
                <div *ngFor="let item of demand.items">
                  <div *ngIf="item.supplier">
                    <strong>{{ item.supplier.name }}</strong>
                    <div class="ms-2">
                      • {{ item?.item?.name }} ({{ item.requestedQuantity }} {{ item?.item?.unit?.symbol }})
                    </div>
                  </div>
                  <div *ngIf="!item.supplier">
                    • {{ item?.item?.name }} ({{ item.requestedQuantity }} {{ item?.item?.unit?.symbol }})
                    <small class="text-muted">(No supplier assigned)</small>
                  </div>
                </div>
              </div>
            </td>
            <td>
              <span class="badge" [ngClass]="getStatusClass(demand.status)">
                {{ demand.status || 'ending' }}
              </span>
            </td>
            <td>{{ demand?.creator?.fullName }}</td>
            <td>{{ demand.demandDate | date:'mediumDate' }}</td>
            <td class="d-flex gap-2">
              <button class="btn btn-sm btn-info" (click)="viewDemand(demand)" ngbTooltip="View Details">
                <i class="ri-eye-line"></i>
              </button>
              <!-- <button class="btn btn-sm btn-success" (click)="editDemand(demand)" ngbTooltip="Edit">
                <i class="ri-edit-2-line"></i>
              </button> -->
              <button class="btn btn-sm btn-danger" (click)="deleteDemand(demand.id)" ngbTooltip="Delete">
                <i class="ri-delete-bin-line"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="demands.length > 0" class="mb-2 row">
        <div class="dataTables_info mb-2 col col-sm-6">
            Showing {{ (page - 1) * pageSize + 1 }}
            to {{ getMin(page * pageSize, totalItems) }}
            of {{ totalItems }} entries
        </div>
        <div class="col col-sm-6">
            <div class="text-sm-end float-end listjs-pagination">
                <ngb-pagination
                    [collectionSize]="totalItems"
                    [(page)]="page"
                    [pageSize]="pageSize"
                    (pageChange)="changePage($event)">
                </ngb-pagination>
            </div>
        </div>
    </div>
  </div>

   
  </div>
</div>
